import { render, staticRenderFns } from "./roomReservationPage.vue?vue&type=template&id=18e08dd0&scoped=true&"
import script from "./roomReservationPage.vue?vue&type=script&lang=js&"
export * from "./roomReservationPage.vue?vue&type=script&lang=js&"
import style0 from "./roomReservationPage.vue?vue&type=style&index=0&id=18e08dd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e08dd0",
  null
  
)

export default component.exports